import { render, staticRenderFns } from "./ListCargaOpenlogView.vue?vue&type=template&id=757f22d2&"
import script from "./ListCargaOpenlogView.vue?vue&type=script&lang=ts&"
export * from "./ListCargaOpenlogView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports